import { CreateNotificationLayout } from './create';
import { TableLayout as NotificationsTableLayout } from './list';
import { NotificationsToolbar } from './list/components/Toolbar';

import type { PageHandleV2 } from '@/layouts/MainLayout/MainLayout.config';
import type { RouteObject } from 'react-router-dom';

export const notificationRoutes: RouteObject[] = [
	{
		path: 'notifications',
		children: [
			{
				index: true,
				element: <NotificationsTableLayout />,
				handle: {
					title: 'Notifications',
					displayFilter: true,
					displaySearchFilter: true,
					displayTimeFilter: true,
					toolbar: NotificationsToolbar,
					actions: [
						{
							type: 'round-button',
							title: '',
							path: 'templates',
						},

						{
							type: 'button',
							title: 'New Notification',
							path: 'notifications/create',
						},
					],
				} satisfies PageHandleV2,
			},
			{
				path: 'create',
				element: <CreateNotificationLayout />,
				handle: {
					title: 'Notifications',
					isChild: true,
					actions: [],
					displayFilter: false,
					displaySearchFilter: false,
					displayTimeFilter: false,
				} satisfies PageHandleV2,
			},
		],
	},
];
